var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages } from './messages';
import utils from './utils/utils';
import { UploadListActionButton } from './UploadListActionButton';
/**
 * @hidden
 */
var UploadListSingleItem = /** @class */ (function (_super) {
    __extends(UploadListSingleItem, _super);
    function UploadListSingleItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    UploadListSingleItem.prototype.getFileExtension = function (file) {
        return file.extension ? file.extension.substring(1) : '';
    };
    /**
     * @hidden
     */
    UploadListSingleItem.prototype.getFileValidationMessage = function (file) {
        var validationMessage = '';
        if (file.validationErrors && file.validationErrors.length > 0) {
            var localizationService = provideLocalizationService(this);
            var messageKey = "upload." + file.validationErrors[0];
            validationMessage = localizationService.toLanguageString(messageKey, messages[messageKey]);
        }
        return validationMessage;
    };
    /**
     * @hidden
     */
    UploadListSingleItem.prototype.renderValidationError = function (file) {
        var exclamation = '!';
        return ([
            (React.createElement("span", { className: 'k-file-invalid-extension-wrapper', key: '1' },
                React.createElement("span", { className: 'k-file-invalid-icon' }, exclamation),
                React.createElement("span", { className: 'k-file-state' }))),
            (React.createElement("span", { className: 'k-file-name-size-wrapper', key: '2' },
                React.createElement("span", { className: 'k-file-name k-file-name-invalid', title: file.name }, file.name),
                React.createElement("span", { className: 'k-file-validation-message' }, this.getFileValidationMessage(file))))
        ]);
    };
    /**
     * @hidden
     */
    UploadListSingleItem.prototype.renderFileDetails = function (file) {
        return ([
            (React.createElement("span", { className: 'k-file-extension-wrapper', key: '1' },
                React.createElement("span", { className: 'k-file-extension' }, this.getFileExtension(file)),
                React.createElement("span", { className: 'k-file-state' }))),
            (React.createElement("span", { className: 'k-file-name-size-wrapper', key: '2' },
                React.createElement("span", { className: 'k-file-name', title: file.name }, file.name),
                React.createElement("span", { className: 'k-file-size' }, utils.getTotalFilesSizeMessage([file]))))
        ]);
    };
    /**
     * @hidden
     */
    UploadListSingleItem.prototype.render = function () {
        var _a = this.props, files = _a.files, others = __rest(_a, ["files"]);
        var file = files[0];
        var itemClassName = classNames('k-file-single');
        return (React.createElement("div", { className: itemClassName },
            React.createElement("span", { className: 'k-progress', style: {
                    width: (file.progress || 0) + '%',
                    transition: 'opacity .5s ease-in-out'
                } }),
            file.validationErrors && file.validationErrors.length > 0 ?
                this.renderValidationError(file) :
                undefined,
            !file.validationErrors || file.validationErrors.length === 0 ?
                this.renderFileDetails(file) :
                undefined,
            React.createElement(UploadListActionButton, __assign({ uid: file.uid, status: file.status, progress: file.progress }, others))));
    };
    return UploadListSingleItem;
}(React.Component));
export { UploadListSingleItem };
registerForLocalization(UploadListSingleItem);
//# sourceMappingURL=UploadListSingleItem.js.map